import React, { useState, useEffect, useCallback } from "react";
import Swal from 'sweetalert2';
import { useAuth } from "../../Context/auth";
import MenuLateral from "../../Components/MenuPrincipal/MenuLateral";
import './Modulos.css';

function Modulos() {
    const { currentUser } = useAuth();
    const [modulos, setModulos] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState('');

    const buscarModulos = useCallback(async () => {
        if (!currentUser) return;
        setCarregando(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;

            const response = await fetch(`${API_URL}/api/modulos`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Erro ao buscar módulos.");
            }
            const data = await response.json();
            setModulos(data);
        } catch (error) {
            console.error("Erro ao carregar módulos:", error);
            setErro(error.message);
        } finally {
            setCarregando(false);
        }
    }, [currentUser]);

    useEffect(() => {
        buscarModulos();
    }, [buscarModulos]);

    const handleAdicionar = async () => {
        const { value: formValues } = await Swal.fire({
            title: 'Novo Módulo',
            html:
                '<input id="swal-input1" class="swal2-input" placeholder="Nome do Módulo">' +
                '<input id="swal-input2" class="swal2-input" placeholder="Valor (R$)" type="number" step="0.01">',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Salvar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                return [
                    document.getElementById('swal-input1').value,
                    document.getElementById('swal-input2').value
                ]
            }
        });

        if (formValues) {
            const [nome, valor] = formValues;
            if (!nome || !valor) {
                Swal.fire('Erro', 'Preencha todos os campos.', 'error');
                return;
            }

            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/modulos`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ nome, valor })
                });

                if (!response.ok) throw new Error('Erro ao criar módulo');

                buscarModulos();
                Swal.fire('Sucesso', 'Módulo criado com sucesso!', 'success');
            } catch (error) {
                Swal.fire('Erro', error.message, 'error');
            }
        }
    };

    const handleEditar = async (modulo) => {
        const { value: formValues } = await Swal.fire({
            title: 'Editar Módulo',
            html:
                `<input id="swal-input1" class="swal2-input" placeholder="Nome" value="${modulo.nome}">` +
                `<input id="swal-input2" class="swal2-input" placeholder="Valor" type="number" step="0.01" value="${modulo.valor}">`,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Salvar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                return [
                    document.getElementById('swal-input1').value,
                    document.getElementById('swal-input2').value
                ]
            }
        });

        if (formValues) {
            const [nome, valor] = formValues;
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/modulos/${modulo.id}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ nome, valor })
                });

                if (!response.ok) throw new Error('Erro ao atualizar módulo');

                buscarModulos();
                Swal.fire('Sucesso', 'Módulo atualizado!', 'success');
            } catch (error) {
                Swal.fire('Erro', error.message, 'error');
            }
        }
    };

    const handleExcluir = async (id) => {
        const result = await Swal.fire({
            title: 'Tem certeza?',
            text: "Você não poderá reverter isso!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!'
        });

        if (result.isConfirmed) {
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/modulos/${id}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error('Erro ao excluir módulo');

                buscarModulos();
                Swal.fire('Deletado!', 'O módulo foi excluído.', 'success');
            } catch (error) {
                Swal.fire('Erro', error.message, 'error');
            }
        }
    };

    return (
        <div className="modulos-page-container">
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="header-container">
                    <h1><i className="fas fa-cubes"></i> Gerenciamento de Módulos</h1>
                    <button className="btn-primary-custom" onClick={handleAdicionar}>
                        <i className="fas fa-plus"></i> Novo Módulo
                    </button>
                </div>

                <div className="modulos-content">
                    {erro && <div className="alert alert-danger">{erro}</div>}

                    {carregando ? (
                        <div className="spinner-container">
                            <div className="spinner-border text-primary" role="status"></div>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nome</th>
                                        <th>Valor (R$)</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {modulos.map(modulo => (
                                        <tr key={modulo.id}>
                                            <td>{modulo.id}</td>
                                            <td>{modulo.nome}</td>
                                            <td>{Number(modulo.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                            <td>
                                                <button className="btn btn-sm btn-info me-2" onClick={() => handleEditar(modulo)}>
                                                    <i className="fas fa-edit"></i>
                                                </button>
                                                <button className="btn btn-sm btn-danger" onClick={() => handleExcluir(modulo.id)}>
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    {modulos.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center">Nenhum módulo encontrado.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Modulos;
